// AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
// Generated by scripts/fetch-custom-models.ts at build time from GCS.
import type { ModelConfigurationType } from "@app/types/assistant/models/types";

export const CUSTOM_MODEL_CONFIGS: ModelConfigurationType[] = [];

export const CUSTOM_MODEL_IDS = [] as const;
